import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {AUTHENTICATED_ENTRY, isMobileApp} from 'configs/AppConfig';
import * as RoutesConfig from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
import {getUrlFromkey} from '../configs/NavigationConfig';
import {useSelector} from 'react-redux';

const Routes = () => {
    const {access} = useSelector((state) => state.auth);

    let defaultUrl = AUTHENTICATED_ENTRY;
    if (!isMobileApp && access?.defaultUrlKey) {
        const defaultAccessUrl = getUrlFromkey(access.defaultUrlKey);
        if (defaultAccessUrl) {
            defaultUrl = defaultAccessUrl;
        }
    }

    return (
        <Switch>
            {/* Public Routes */}
            {RoutesConfig.publicRoutes.map((route) => (
                <Route
                    exact
                    key={route.path}
                    path={route.path}
                    render={(props) => (
                        <PublicRoute {...props}>
                            <AppRoute
                                {...props}
                                routeKey={route.key}
                                component={route.component}
                                {...route}
                            />
                        </PublicRoute>
                    )}
                />
            ))}

            {/* Protected Routes */}
            <Route
                path="/"
                render={(props) => (
                    <ProtectedRoute {...props}>
                        <Switch>
                            {/* Redirection vers defaultUrl */}
                            <Route exact path="/" render={() => <Redirect to={defaultUrl} />} />

                            {RoutesConfig.protectedRoutes.map((route, index) => (
                                <Route
                                    exact
                                    key={route.key + index}
                                    path={route.path}
                                    render={(props) => (
                                        <AppRoute
                                            {...props}
                                            routeKey={route.key}
                                            component={route.component}
                                            {...route}
                                        />
                                    )}
                                />
                            ))}

                            {/* Fallback */}
                            <Route render={() => <Redirect to="/" />} />
                        </Switch>
                    </ProtectedRoute>
                )}
            />
        </Switch>
    );
};

export default Routes;
